import React from 'react';
import CustomReportTable from './Table';
import { CustomReportButtonProvider } from './useCustomReport';

const CustomReportButton = ({ data = {} }) => {
  return (
    <CustomReportButtonProvider data={data}>
      <CustomReportTable />
    </CustomReportButtonProvider>
  );
};

export default CustomReportButton;
